<template>
	<div id="Admin">
		<v-toolbar card prominent>
			<v-toolbar-title class="body-2 grey--text">Administração de Sites</v-toolbar-title>
			<v-spacer></v-spacer>

			<!-- //TODO: Adicionar campo de busca na lista de sites -->
			<v-tooltip bottom>
				<v-btn icon slot="activator">
					<v-icon>search</v-icon>
				</v-btn>
				<span>Procurar</span>
			</v-tooltip>


			<v-tooltip bottom>
				<v-btn icon @click="archievedModal.enabled = true" slot="activator">
					<v-icon>folder</v-icon>
				</v-btn>
				<span>Sites Arquivados</span>
			</v-tooltip>
			<v-tooltip bottom>
				<v-btn icon @click="newSiteModal.enabled = true" slot="activator">
					<v-icon>add</v-icon>
				</v-btn>
				<span>Novo Site</span>
			</v-tooltip>

			<!--//* Criar novo site -->
			<v-dialog v-model="newSiteModal.enabled" max-width="600px">
				<v-card>
					<v-card-title>
						<span class="headline">Adicionar Site</span>
					</v-card-title>
					<v-card-text>
						<v-container grid-list-md>
							<v-layout wrap>
								<v-flex xs12>
									<v-text-field v-model="siteName" label="Nome do Site" required></v-text-field>
								</v-flex>
								<v-flex xs12>
									<small>Alias</small>
									<pre style="border-bottom: 1px solid gray">{{alias}}</pre>
								</v-flex>
							</v-layout>
						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue darken-1" flat @click="newSiteModal.enabled = false">Cancelar</v-btn>
						<v-btn color="green darken-1" dark @click="saveSite()">Salvar</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<!--//* Editar nome do site  -->
			<v-dialog v-model="editSiteModal.enabled" max-width="600px">
				<v-card>
					<v-card-title>
						<span class="headline">Editar Site</span>
					</v-card-title>
					<v-card-text>
						<v-container grid-list-md>
							<v-layout wrap>
								<v-flex xs12>
									<v-text-field v-model="siteName" label="Nome do Site" required></v-text-field>
								</v-flex>
								<v-flex xs12>
									<small>Alias</small>
									<pre style="border-bottom: 1px solid gray">{{alias}}</pre>
								</v-flex>
							</v-layout>
						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue darken-1" flat @click="editSiteModal.enabled = false">Cancelar</v-btn>
						<v-btn color="green darken-1" dark @click="saveEdit()">Salvar</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<!--//* Arquivar site  -->
			<v-dialog v-model="archiveSiteModal.enabled" max-width="600px">
				<v-card>
					<v-card-title>
						<span class="headline">Arquivar {{siteName}}?</span>
					</v-card-title>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue darken-1" flat @click="archiveSiteModal.enabled = false">Cancelar</v-btn>
						<v-btn color="orange darken-1" dark @click="saveArchive()">Arquivar</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<!--//*Ativar site  -->
			<v-dialog v-model="activeSiteModal.enabled" max-width="600px">
				<v-card>
					<v-card-title>
						<span class="headline">Ativar {{siteName}}</span>
					</v-card-title>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue darken-1" flat @click="activeSiteModal.enabled = false">Cancelar</v-btn>
						<v-btn color="orange darken-1" dark @click="confirmActiveSite()">Ativar</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<!--//* Deletar site  -->
			<v-dialog v-model="deleteSiteModal.enabled" max-width="600px">
				<v-card>
					<v-card-title>
						<span class="headline">Deletar {{siteName}}?</span>
					</v-card-title>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue darken-1" flat @click="deleteSiteModal.enabled = false">Cancelar</v-btn>
						<v-btn color="error darken-1" @click="confirmDelete()">DELETAR</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<!--//* ver sites arquivados  -->
			<v-dialog v-model="archievedModal.enabled" max-width="600px">
				<v-card>
					<v-card-title>
						<span class="headline">Sites arquivados</span>
					</v-card-title>
					<v-card-text>
						<v-data-table :headers="headers" :items="sitesArquivados"
							rows-per-page-text="Colunas por página:"
							no-data-text="Não há nenhum site arquivado."
							no-results-text="Sua busca não encontrou resultados.">
							<template slot="items" slot-scope="props">
								<td class="subheading pa-2 text-xs-left" :class="[props.item.status, props.item.situation]">{{ props.item.nome }} -
									<b>{{props.item.status}}</b>
									<div class="text-xs-right">
										<v-tooltip bottom>
											<v-icon slot="activator" class="px-2" color="success" @click="edit(props.item)">edit</v-icon>
											<span>Editar</span>
										</v-tooltip>
										<v-tooltip bottom v-if="props.item.status != 'arquivado'">
											<v-icon slot="activator" class="px-2" color="amber darken-2" @click="archive(props.item)">archive</v-icon> 
											<span>Arquivar</span>
										</v-tooltip>
										<v-tooltip bottom v-else>
											<v-icon slot="activator" class="px-2" color="info" @click="activeSite(props.item)">unarchive</v-icon> 
											<span>Desfazer Arquivar</span>
										</v-tooltip>
										<v-tooltip bottom>
											<v-icon slot="activator" class="px-2" color="error" @click="remove(props.item)">delete</v-icon> 
											<span>Deletar</span>
										</v-tooltip>
									</div>
								</td>
							</template>
							<template slot="pageText" slot-scope="props">
								{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
							</template>
						</v-data-table>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue darken-1" flat @click="archievedModal.enabled = false">Voltar</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

		</v-toolbar>

		<v-divider></v-divider>
		<v-card-text>
			<!-- //*Data table dos sites -->
			<v-data-table :headers="headers" :items="sites" light
				rows-per-page-text="Colunas por página:"
				no-data-text="Não há nenhum site ativo."
				no-results-text="Sua busca não encontrou resultados.">
				<template slot="items" slot-scope="props">
					<td class="subheading pa-2 text-xs-left" :class="[props.item.status, props.item.situation]">{{ props.item.nome }}
							<span>
								<v-tooltip bottom>
									<v-icon small slot="activator" class="px-2" @click="edit(props.item)">edit</v-icon>
									<span>Mudar nome</span>
								</v-tooltip>
							</span>
							<span class="r-float-right">
								<v-tooltip bottom>
									<v-icon slot="activator" class="px-2" color="primary" @click="$router.push({ name: 'paginas', query: {siteId: props.item['.key']}})">insert_drive_file
</v-icon>
									<span>Visualizar páginas</span>
								</v-tooltip>
								<v-tooltip bottom>
									<v-icon slot="activator" class="px-2" color="success" @click="$router.push({ name: 'verPagina', query: {siteId: props.item['.key'] }})">share
</v-icon>
									<span>Criar link único</span>
								</v-tooltip>
								<v-tooltip bottom v-if="props.item.status != 'arquivado'">
									<v-icon slot="activator" class="px-2" color="amber darken-2" @click="archive(props.item)">archive</v-icon> 
									<span>Arquivar</span>
								</v-tooltip>
								<v-tooltip bottom v-else>
									<v-icon slot="activator" class="px-2" color="info" @click="activeSite(props.item)">unarchive</v-icon> 
									<span>Desfazer Arquivar</span>
								</v-tooltip>
								<v-tooltip bottom>
									<v-icon slot="activator" class="px-2" color="error" @click="remove(props.item)">delete</v-icon> 
									<span>Deletar</span>
								</v-tooltip>
							</span>
					</td>
				</template>
				<template slot="pageText" slot-scope="props">
					{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
				</template>
			</v-data-table>
		</v-card-text>
	</div>
</template>

<script>
//*Importar banco de dados do firebase
import { db } from '../firebase'

//* Constante de referenciação do banco de dados
const sitesRef = db.ref('sites')

export default {
	name: 'Admin',

	firebase(){
		return {
			//*Variáveis que recebem a referência
			sites: {
				source: sitesRef.orderByChild('status').equalTo('ativo')
			}, 
			sitesArquivados: {
				source: sitesRef.orderByChild('status').equalTo('arquivado')
			}
		}
	},

	data () {
		return {
			//*Cariáveis para definiçaõ de nome do site
			alias: '',
			siteName: '',

			//* Modal para criar novo site
			newSiteModal: {
				enabled: false,
				selectedSite: null,
			},
			//* Modal para editar o nome do site
			editSiteModal: {
				enabled: false,
				selectedSite: null
			},
			//* Modal para arquivar o site
			archiveSiteModal: {
				enabled: false,
				selectedSite: null
			},
			//* Modal para ativar o site
			activeSiteModal: {
				enabled: false,
				selectedSite: null
			},
			//* Modal para deletar o site
			deleteSiteModal: {
				enabled: false,
				selectedSite: null
			},
			archievedModal: {
				enabled: false,
				selectedSite: null,
			},
			//* Variáveis para a exibição da datalist
			headers: [
				{
					text: 'Sites',
					align: 'center',
					sortable: false,
					value: 'name'
				},
			],
			//*Variaveis que recebem o banco de dados
			sites: {},
			sitesArquivados: {},
		}
	},
	methods: {
		//* Converte qualquer string em URL-friendly (Para salvar o site no db) 
		specialCharMask (especialChar){					
			if(especialChar){
				especialChar = especialChar.replace(/[áàãâä]/g, 'a')
				especialChar = especialChar.replace(/[éèêë]/g, 'e')
				especialChar = especialChar.replace(/[íìîï]/g, 'i')
				especialChar = especialChar.replace(/[óòõôö]/g, 'o')
				especialChar = especialChar.replace(/[úùûü]/g, 'u')
				especialChar = especialChar.replace(/ç/g, 'c')
				especialChar = especialChar.replace(/\s/g, '_')
				especialChar = especialChar.toLowerCase()
				especialChar = especialChar.replace(/[^a-z0-9_]/g, '')
				// console.log(especialChar)
				this.alias = especialChar
				return especialChar
			}
			
		},
		//* Salvar Site no db
		saveSite() {
			this.newSiteModal.enabled = false
			// Adicionar no bd
			var novoSite = db.ref('sites').push()
			novoSite.set({
				nome: this.siteName,
				alias: this.alias,
				content: '',
				status: 'ativo',
				situation: 'none',
			})
			
			this.clearFields()
		},
		//* Botões de opção
		edit(site){
			this.clearFields()
			this.editSiteModal.enabled = true
			this.editSiteModal.siteKey = site['.key']
			this.siteName = site.nome
		},
		saveEdit(){
			// console.log(this.editSiteModal.siteKey)

			sitesRef.child(this.editSiteModal.siteKey).update({
				nome: this.siteName,
				alias: this.alias
			}).then(function(){
				// console.log('Deu bom')
				this.clearFields()
				this.editSiteModal.enabled = false
			}.bind(this))
		},
		remove(site){
			this.clearFields()
			this.deleteSiteModal.enabled = true
			this.deleteSiteModal.siteKey = site['.key']
			this.siteName = site.nome
		},
		confirmDelete(){
			// console.log(this.deleteSiteModal.siteKey)

			sitesRef.child(this.deleteSiteModal.siteKey).remove().then(function(){
				// console.log('Deletou!')
				this.clearFields()
				this.deleteSiteModal.enabled = false
			}.bind(this))
		},
		archive(site) {
			this.clearFields()
			this.archiveSiteModal.enabled = true
			this.archiveSiteModal.siteKey = site['.key']
			this.siteName = site.nome
		},
		saveArchive(){
			// console.log(this.archiveSiteModal.siteKey)

			sitesRef.child(this.archiveSiteModal.siteKey).update({
				status: 'arquivado'
			}).then(function(){
				// console.log('Deu bom')
				this.clearFields()
				this.archiveSiteModal.enabled = false
			}.bind(this))
		},
		activeSite(site) {
			this.clearFields()
			this.activeSiteModal.enabled = true
			this.activeSiteModal.siteKey = site['.key']
			this.siteName = site.nome
		},
		confirmActiveSite() {
			// console.log(this.activeSiteModal.siteKey)

			sitesRef.child(this.activeSiteModal.siteKey).update({
				status: 'ativo'
			}).then(function(){
				// console.log('Deu bom')
				this.clearFields()
				this.activeSiteModal.enabled = false
			}.bind(this))
		},
		clearFields(){
			this.siteName = null
			this.alias = null
		}


	},
	watch: {
		siteName: {
			deep: true,
			handler(val) {
				this.alias = this.specialCharMask(val)
			}
		}
	},
}
</script>

<style lang="sass">
// *Style da Resultam
.r-float-right
	float: right
	
// *Alterações de Style do Vuetify
.column 
		font-size: 20px !important

// *Variaveis para estados do site
.aprovado
	border-left: 15px solid rgba(0, 255, 0, 0.6)
.reprovado
	border-left: 15px solid rgba(255, 0, 0, 0.6)

</style>